import { http } from "./httpClient";

export const instagramApi = {
  getAccounts: () => http.get("/instagram/accounts/"),
  getAccount: (id) => http.get(`/instagram/accounts/${id}/`),

  /**
   * Kicks off the real Facebook Login for Business OAuth flow: asks the
   * backend for the signed authorization URL, then navigates the whole
   * browser there (Facebook's OAuth dialog cannot run inside an iframe/XHR).
   */
  async startConnect({ requestComments = false, accountId = null } = {}) {
    const { auth_url } = await http.get(`/instagram/oauth/start/${requestComments ? `?comment_access=1&account_id=${encodeURIComponent(accountId || '')}` : ''}`);
    if (requestComments) {
      try { sessionStorage.setItem('rr_comment_access_reconnect', '1'); } catch { /* OAuth still works without browser storage. */ }
    }
    window.location.href = auth_url;
  },

  /** Real location search (Reels only) via Meta's Pages Search API -- see routes/instagram.js. */
  searchLocations: (accountId, q) =>
    http.get(`/instagram/location-search/?instagram_account=${encodeURIComponent(accountId)}&q=${encodeURIComponent(q)}`),

  /** Real audio/music search (Reels only) via Meta's Instagram Audio API -- see routes/instagram.js. */
  searchAudio: (accountId, audioType, q) =>
    http.get(`/instagram/audio-search/?instagram_account=${encodeURIComponent(accountId)}&audio_type=${audioType}&q=${encodeURIComponent(q || "")}`),
};
